import { createSlice } from "@reduxjs/toolkit";
import { FetchingTypes } from "../interfaces/types";

export interface initialStateReportProps {
    offer: OfferProps[],
    fetching: FetchingTypes
}

const initialState: initialStateReportProps = {
    offer: [],
    fetching: "unknown"
}

const offerSlice = createSlice({
    name: 'offer',
    initialState,
    reducers: {
        getOfferUserRequest: (state) => {
            state.fetching = "loading";
        },
        getOfferUserSuccess: (state, action) => {
            state.fetching = "success";
            state.offer = action.payload
        },
        getOfferUserFailure: (state) => {
            state.fetching = "failure";
        },
        
    }
});

export const {
    getOfferUserRequest, 
    getOfferUserSuccess, 
    getOfferUserFailure
} = offerSlice.actions;

export default offerSlice.reducer;